// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1E4Na","colMaxWidth":"Table_colMaxWidth__cXVwq"};